"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceInfo = function (_Component) {
  (0, _inherits3.default)(ServiceInfo, _Component);

  function ServiceInfo() {
    (0, _classCallCheck3.default)(this, ServiceInfo);
    return (0, _possibleConstructorReturn3.default)(this, (ServiceInfo.__proto__ || (0, _getPrototypeOf2.default)(ServiceInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(ServiceInfo, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Tietoa palvelusta" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              "Tietoa palvelusta"
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Ilmoita ilmaiseksi"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Ilmoita Maap\xF6rssiss\xE4, kun tarvitset tai haluat tarjota puhtaita maa-aineksia. Maapo\u0308rssin ilmoituspalstaa seuraa parhaimpina kuukausina noin 3.000 silma\u0308paria. Ilmoittaminen on ilmaista eika\u0308 sido sinua mihinka\u0308a\u0308n. Ilmoitukset ovat arvioita ja siksi tarkemmat yksityiskohdat voidaan sopia ilmoituksessa mainittuja yhteystietoja k\xE4ytt\xE4en. Ilmoita vaikka tiedossasi olisi \u201Csopiva\u201D tyo\u0308maa. Aina voit lo\u0308yta\u0308a\u0308 paremman.",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/jata-ilmoitus" },
                "J\xE4t\xE4 ilmainen ilmoitus t\xE4st\xE4 linkist\xE4"
              ),
              "."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Kun sinulla on vaihtoehtoja, voit:",
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "ul",
                null,
                _react2.default.createElement(
                  "li",
                  null,
                  "neuvotella kuljetuskustannuksista"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "neuvotella maa-ainesten vastaanottamisesta"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "neuvotella maa-ainesten luovuttamisesta"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "lo\u0308yta\u0308a\u0308 tyo\u0308maan lyhemma\u0308lta\u0308 eta\u0308isyydelta\u0308"
                )
              )
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Lipukkeita viikon jokaisena pa\u0308iva\u0308na\u0308, kellon ympa\u0308ri"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Maapo\u0308rssin sivustolla toimivasta kaupasta ostat vastaanottolipukkeet helposti. Vastaanottolipukkeet oikeuttavat viem\xE4\xE4n puhtaita maa-aineksia lipukkeen vastaanottopaikalle lipukkeessa mainituin ehdoin. Kauppa on auki kellon ympa\u0308ri joten voit hankkia lipukkeita, kun sinulle sopii. Lipukkeet ovat valmiiksi siirtoasiakirjapohjaisia ja voit la\u0308hetta\u0308a\u0308 ne kuskeille ka\u0308teva\u0308sti sa\u0308hko\u0308postilla tai ka\u0308ytta\u0308a\u0308 itse.",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/lipukekauppa" },
                "Lipukekauppaan pa\u0308a\u0308set ta\u0308sta\u0308 linkista\u0308"
              ),
              "."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h5" },
              "Yleiset maksutavat ka\u0308yto\u0308ssa\u0308si"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Vastaanottolipukkeet voit maksaa joko tilisiirtona tai luottokortilla. Myo\u0308s laskulla maksaminen on mahdollista. Jos haluat yrityksellesi oikeuden maksaa laskulla, soita numeroon",
              " ",
              _react2.default.createElement(
                "a",
                { href: "tel:+358444279803" },
                "044 427 9803"
              ),
              " tai la\u0308heta\u0308 postia osoitteeseen",
              " ",
              _react2.default.createElement(
                "a",
                { href: "mailto:asiakaspalvelu@maaporssi.fi" },
                "asiakaspalvelu@maaporssi.fi"
              ),
              "."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h5" },
              "Lipukekauppa on projektien rahoitustyo\u0308kalu"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Perim\xE4ll\xE4 maksua puhtaiden maa-ainesten vastaanotosta saat tarvitsemiesi maa-ainesten lis\xE4ksi ansaittua projektillesi tulorahoitusta. Maap\xF6rssin lipukekauppa on tehokas tapa myyd\xE4 vastaanottolipukkeita pidempiaikaisille ty\xF6maille. Hoidamme markkinoinnin ja lipukemyynti\xE4 koskevan tiedottamisen puolestasi. Pyyda\u0308 ilmainen arvio numerosta",
              " ",
              _react2.default.createElement(
                "a",
                { href: "tel:+358444279803" },
                "044 427 9803"
              ),
              "."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h5" },
              "Lupa-asiat kuntoon ilman alkupa\u0308a\u0308omaa"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Ylij\xE4\xE4m\xE4maa-ainesten vastaanottoon liittyviin ymp\xE4rist\xF6lupiin ei tarvita alkup\xE4\xE4omaa, kun asioit Maap\xF6rssin kautta. Lupien kustannukset voidaan kattaa lipukekaupasta saaduilla tuloilla."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Rekistero\u0308ityma\u0308lla\u0308 saat enemma\u0308n"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Ollessasi kirjautuneena sisa\u0308a\u0308n omalla profiilillasi, yhteystietosi ovat esita\u0308ytettyina\u0308 lipukekaupassa ja ilmoitusta ja\u0308tta\u0308essa\u0308si. Profiilillasi pa\u0308a\u0308set myo\u0308s muokkaamaan ja\u0308tta\u0308mia\u0308si ilmoituksia. Tutustu",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/kayttoehdot" },
                "palvelun k\xE4ytt\xF6ehtoihin ja rekisteriselosteeseen"
              ),
              "."
            ),
            _react2.default.createElement(
              "h5",
              { className: "h5" },
              "Yksityisprofiili"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Yksityisprofiili on tarkoitettu yksityisille talonrakentajille. Kun ole rekistero\u0308inyt Yksityisprofiilin, pa\u0308a\u0308set lukemaan ilmoitusten tarkat tiedot seka\u0308 na\u0308et kartalta ilmoituskohteiden todelliset sijainnit. Ilmoitusten tarkat tiedot eiva\u0308t na\u0308y ka\u0308ytta\u0308jille joilla ei ole Yksityisprofiilia tai Ammattilaisprofiilia.",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/maksullinen-profiili" },
                "Yksityisprofiilin pa\u0308a\u0308set rekistero\u0308ima\u0308a\u0308n ta\u0308sta\u0308 linkista\u0308"
              ),
              "."
            ),
            _react2.default.createElement(
              "h5",
              { className: "h5" },
              "Ammattilaisprofiili"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Ammattilaisprofiilin on tarkoitettu maarakennusalan seka\u0308 kuljetusalan ammattilaiska\u0308ytto\u0308o\u0308n.",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/maksullinen-profiili" },
                "Ammattilaisprofiilin p\xE4\xE4set rekister\xF6im\xE4\xE4n t\xE4st\xE4 linkist\xE4"
              ),
              "."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Ammattilaisprofiililla:",
              _react2.default.createElement(
                "ul",
                null,
                _react2.default.createElement(
                  "li",
                  null,
                  "pa\u0308a\u0308set lukemaan ilmoitusten tarkat tiedot ja na\u0308et kartalla ilmoitusten kohteiden oikeat sijainnit"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "vastaanotat Lipukekauppaa ja sen vastaanottokohteita koskevia tiedotteita"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "vastaanotat viikoittaisen \u201DViikon vinkit\u201D -uutiskirjeen jossa listataan viikon kiinnostavimmat ilmoitukset"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "pa\u0308a\u0308set kirjautumaan Maapo\u0308rssin kuljetussovellukseen jolla luot digitaaliset siirtoasiakirjat ja Maap\xF6rssin sivustolta Exceliin ladattavat kuljetusraportit"
                )
              ),
              "Maapo\u0308rssin kuljetussovelluksen voit ladata puhelimeesi tai tablettiisi",
              " ",
              _react2.default.createElement(
                "a",
                { href: "https://play.google.com/store/apps/details?id=fi.maaporssi.app&hl=fi" },
                "Androidille"
              ),
              " ",
              "tai",
              " ",
              _react2.default.createElement(
                "a",
                { href: "https://itunes.apple.com/fi/app/maap%C3%B6rssi/id1191743095?mt=8" },
                "iOS:lle"
              ),
              ". Sisa\u0308a\u0308n pa\u0308a\u0308set kirjautumaan Ammattilaisprofiilisi tunnuksilla."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Lisa\u0308a\u0308 tietoa palvelustamma saat soittamalla numeroon",
              " ",
              _react2.default.createElement(
                "a",
                { href: "tel:+358444279803" },
                "044 427 9803"
              ),
              " tai la\u0308hetta\u0308ma\u0308lla\u0308 postia osoitteeseen",
              " ",
              _react2.default.createElement(
                "a",
                { href: "mailto:asiakaspalvelu@maaporssi.fi" },
                "asiakaspalvelu@maaporssi.fi"
              ),
              "."
            )
          )
        )
      );
    }
  }]);
  return ServiceInfo;
}(_react.Component);

exports.default = ServiceInfo;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ServiceInfo/ServiceInfo.js
 ** module id = 1243
 ** module chunks = 0
 **/